import LogRocket from 'logrocket';
import { isNotRunningLocally } from '@stilingue/st-environment-controller-utils';

const shouldStartLockRocket = isNotRunningLocally();

if (shouldStartLockRocket) {
  LogRocket.init('asbycy/stilingue-boilerplate', { shouldAugmentNPS: false });
}

export function insertLogRocketMetadata({
  name,
  email,
  id,
  user_group,
  user_group_id
} = {}) {
  if ([shouldStartLockRocket, name, email, id, user_group, user_group_id].every(Boolean)) {
    LogRocket.identify(id, {
      name,
      email,
      user_group,
      user_group_id
    });
  }
}

